import React from "react";
import foto from "../../assets/underconst.png";

const Login = () => {
  return (
    <div>
      <img className="d-block m-auto mt-5" src={foto} width={700} alt="" />
    </div>
  );
};

export default Login;
